import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';


export function initBlogItemlistSlider(
    selector = '.blogList .itemboxList.swiper'
) {
    document.querySelectorAll(selector).forEach((sliderEl) => {
        new Swiper(sliderEl, {
            modules: [Autoplay, Navigation, Pagination],
            spaceBetween: 12,
            speed: 300,
            slidesPerView: 1,
        });
    });
}
